export default stream => ({
  i: 0,
  read() {
    return stream[this.i++]
  },
  lookAhead(i = 1) {
    const ahead = this.i + i
    return stream[ahead < stream.length ? ahead : stream.length - 1]
  },
  more(i = 0) {
    return this.i + i < stream.length
  },
})
